<template>
  <v-container fluid id="sidebar" class="px-0 left-sidebar" v-show="$vuetify.display.lgAndUp">
    <FinancialHouse />
    <v-container class="backgroundBlueGradient">
      <MyRep :rep-page="false" :left-side-bar="true" />
    </v-container>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FinancialHouse from './components/FinancialHouse/FinancialHouse.vue';
import { getNav } from '@/shared/navLogic';
import MyRep from '@/modules/myRep/MyRep.vue';

export default defineComponent({
  name: 'LeftSidebar',
  components: {
    FinancialHouse,
    MyRep,
  },
  data: () => ({
    nav: getNav(),
  }),
});
</script>

<style lang="scss" scoped>
.left-sidebar {
  z-index: 10;
  position: absolute;
  display: block;
  top: 64px;
  left: 0;
  bottom: 88px;
  width: 238px;
  overflow: hidden;
}
.backgroundBlueGradient {
  background-image: linear-gradient(to top, #012f60, #013b71);
  position: relative;
  left: 0;
  bottom: 0;
  height: calc(100% - 68px);
}
</style>
